import { render, staticRenderFns } from "./BaseYear.vue?vue&type=template&id=d8d89de8"
import script from "./BaseYear.vue?vue&type=script&lang=js"
export * from "./BaseYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports